export const TacticalMarquee = ({ text }) => (
  <div data-testid="tactical-marquee" className="border-y border-[#272A2E] bg-[#0A0B0D] py-4 overflow-hidden select-none">
    <div className="marquee-track flex whitespace-nowrap">
      {[0, 1].map((n) => (
        <span key={n} className="text-xs font-mono tracking-[0.3em] uppercase text-[#8A8F98] pr-4">
          {text.repeat(4)}
        </span>
      ))}
    </div>
  </div>
);
